window.GeoLocation = {
	city: 'Москва',
	confirm: null,

	getSubdomain: function () {
		return App.citySubdomain;
	},

	setCity: function (city) {
		this.city = city;
	},

	getCity: function () {
		if (App.citySubdomain) {
			return App.citySubdomain.title;
		}

		return this.city;
	},

	getLocation: function () {
		if (this.getSubdomain()) {
			return false;
		}

		GeoLocation.checkConfirm();

		if(GeoLocation.confirm === true) {
			$('[data-location=question]').hide();
		}

		if((!$.cookie('geoLocation-city') || $.cookie('geoLocation-city') === 'undefined') && GeoLocation.confirm !== true) {
			GeoLocation.yaLocation();
		} else {
			GeoLocation.setCity($.cookie('geoLocation-city'));
			GeoLocation.printCity();
		}
	},

	checkConfirm: function () {
		if(!$.cookie('geoLocation-confirmed')) {
			GeoLocation.confirm = null;
		} else if($.cookie('geoLocation-confirmed')) {
			GeoLocation.confirm =  true;
		} else {
			GeoLocation.confirm =  false;
		}
	},

	yaLocation: function () {
		ymaps.ready(init);

		function init() {
			var geolocation = ymaps.geolocation;

			geolocation.get({
				provider: 'yandex',
				autoReverseGeocode: true
			}).then(function (result) {

				var data = result.geoObjects.get(0).properties.get('metaDataProperty'),
					city = data.GeocoderMetaData.Address.Components[4]['name'];

				$.cookie('geoLocation-city', city, { domain: App.SESSION_DOMAIN, 'path': '/' });
				GeoLocation.setCity(city);
				GeoLocation.printCity();
			});
		}
	},

	printCity: function () {
		$('[data-location=city]').html(GeoLocation.getCity());
	},

	saveLocation: function () {
		$.cookie('geoLocation-confirmed', true);
		$('[data-location=question]').hide();
		$("#geoLocation").removeClass('show');
		$("#geoLocation").closest('.dropdown').removeClass('show');

		$.get('/location/get_city_domain', {city: GeoLocation.getCity()}, function (data) {
			if (!data.error) {
				if (data.domain) {
					if (data.domain !== location.host) {
						location.href = '//' + data.domain + location.pathname;
					}
				}
			}
		});
	},

	closeLocation: function() {
		$.cookie('geoLocation-closed', true);
		$("#geoLocation").removeClass('show');
		$("#geoLocation").closest('.dropdown').removeClass('show');
	}
};
